import { render, staticRenderFns } from "./categlist_product.vue?vue&type=template&id=0cd08565&scoped=true&"
import script from "./categlist_product.vue?vue&type=script&lang=js&"
export * from "./categlist_product.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd08565",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0cd08565')) {
      api.createRecord('0cd08565', component.options)
    } else {
      api.reload('0cd08565', component.options)
    }
    module.hot.accept("./categlist_product.vue?vue&type=template&id=0cd08565&scoped=true&", function () {
      api.rerender('0cd08565', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/catalog/categories/list/categlist_product.vue"
export default component.exports